import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './forgot.css'
import Loader from '../../components/Loader'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Match from '../../utilities/validation'
import { Link } from 'react-router-dom'
import { invalidEmail, invalidPass, emptyEmail, emptyPassword } from '../../utilities/message'
import { forgotPassword } from '../../actions/user'
import { useLocation } from 'react-router-dom'

const Forgot = ({ loader, history }) => {
    const loaders = useSelector((state) => state.loader)
    const [openModal, setModal] = useState(false)
    const [emailVal, setEmailVal] = useState('')
    const dispatch = useDispatch()
    const location = useLocation()

    const emailInputVal = (event) => {
        setEmailVal(event.target.value.replace(/\s/g, ''))
    }

    useEffect(() => {
        history.listen((newLocation, action) => {
            if (action === 'POP' && newLocation.pathname == '/otpTimer') {
                history.push('/forgotPassword')
            }
           
        })
    }, [])

    //***********MODAL******************* */

    const submitForgot = () => {
        dispatch(
            forgotPassword({ email: emailVal }, (res) => {
                if (res) {
                    history.push('/otpTimer')
                }
            }),
        )
    }

    return (
        <React.Fragment>
            <div>
                <Loader loading={loaders.isFetching} />
                <div className="forgotHeader">
                    <div className="logo-details">
                        <div onClick={()=>history.push('/dashboard')} className="logo2">
                            <img alt="logo" height={120} src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default} />
                        </div>
                    </div>
                </div>
                <div className="forgotDiv">
                    <Box className="forgotPopup">
                        <div className="forgoticonshadow">
                            <i className="forgotIconPopup">
                                <img src={require('../../assets/images/lock3.png')} />
                            </i>
                        </div>
                        <div className="textForgotPopup">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Forgot Password?
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Please enter your Email ID to reset your password
                            </Typography>

                            <Typography>
                                <LocalForm model="user" onSubmit={(values) => submitForgot(values)}>
                                    <Row>
                                        <Col sm="12" md="12">
                                            <FormGroup>
                                                <div className="input-wrapper">
                                                    <i class="forgotemailicon">
                                                        <img
                                                            src={require('../../assets/images/newfile/Email.svg').default}
                                                        />
                                                    </i>
                                                    <Control.text
                                                        model="user.email"
                                                        className="form-control forgotemail input-field"
                                                        id="user.username"
                                                        placeholder="Enter Email"
                                                        value={emailVal}
                                                        onChange={(e) => emailInputVal(e)}
                                                        errors={{
                                                            emptyEmail: (val) => !val,
                                                            invalidEmail: (val) =>
                                                                val &&
                                                                !Match.validateEmail(val.trim()),
                                                        }}
                                                    />
                                                </div>
                                                <Errors
                                                    model="user.email"
                                                    errors={{
                                                        emptyEmail,
                                                        invalidEmail,
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm="12 form-button-spacing">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-block "
                                            >
                                                Submit
                                            </button>
                                        </Col>
                                        <Link to="/">
                                            <Col sm="12 form-button-spacing backlogin">
                                                <p>
                                                    <img
                                                        src={require('../../assets/images/back.png')}
                                                    />
                                                </p>
                                                <p>Back to login</p>
                                            </Col>
                                        </Link>
                                    </Row>
                                </LocalForm>
                            </Typography>
                        </div>
                    </Box>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Forgot
